import React from 'react';


const Box = ({children, style}) => {
    let style1 = "rounded-lg drop-shadow-lg "+style
  return (
    <div className={style1}>
        {children}
    </div>
  );
}

export default Box;